"use strict";
// tslint:disable:max-classes-per-file
/*!
// <copyright file="html-binding-splitter.js" company="Microsoft">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
*/
var $dyn;
(function ($dyn) {
    var splitter;
    (function (splitter) {
        var SplitterModes;
        (function (SplitterModes) {
            SplitterModes["top"] = "Top";
            SplitterModes["bottom"] = "Bottom";
            SplitterModes["left"] = "Left";
            SplitterModes["right"] = "Right";
            SplitterModes["both"] = "Both";
            SplitterModes["none"] = "None";
        })(SplitterModes = splitter.SplitterModes || (splitter.SplitterModes = {}));
        var HandleDirections;
        (function (HandleDirections) {
            HandleDirections["west"] = "w";
            HandleDirections["east"] = "e";
            HandleDirections["north"] = "n";
            HandleDirections["south"] = "s";
        })(HandleDirections = splitter.HandleDirections || (splitter.HandleDirections = {}));
        var CssClasses;
        (function (CssClasses) {
            CssClasses["left"] = "left-splitter";
            CssClasses["right"] = "right-splitter";
            CssClasses["top"] = "top-splitter";
            CssClasses["bottom"] = "bottom-splitter";
        })(CssClasses = splitter.CssClasses || (splitter.CssClasses = {}));
        var Attributes;
        (function (Attributes) {
            Attributes["horizontal"] = "data-dyn-horizontalsplitter";
            Attributes["vertical"] = "data-dyn-verticalsplitter";
        })(Attributes = splitter.Attributes || (splitter.Attributes = {}));
    })(splitter = $dyn.splitter || ($dyn.splitter = {}));
    var bindingHandlers;
    (function (bindingHandlers) {
        /**
         * Initialize a vertical splitter on a control given the direction/side.
         * Moves the splitter to the neighboring control if needed. The non flexible element should be resizable
         */
        var VerticalSplitterBindingHandler = /** @class */ (function () {
            function VerticalSplitterBindingHandler() {
            }
            VerticalSplitterBindingHandler.prototype.shouldInvoke = function (value, lastValue) {
                return lastValue !== value ? lastValue !== undefined || !!value : false;
            };
            VerticalSplitterBindingHandler.prototype.invoke = function (targetElement, value) {
                var element = $(targetElement);
                var verticalSplitterMode = element.attr($dyn.splitter.Attributes.vertical);
                if (value === $dyn.splitter.SplitterModes.none) {
                    if (verticalSplitterMode !== undefined && verticalSplitterMode !== $dyn.splitter.SplitterModes.none) {
                        element.attr($dyn.splitter.Attributes.vertical, $dyn.splitter.SplitterModes.none);
                        $dyn.splitter.RemoveHandle(element, $dyn.splitter.HandleDirections.east);
                        $dyn.splitter.RemoveHandle(element, $dyn.splitter.HandleDirections.west);
                    }
                }
                else {
                    if (value === $dyn.splitter.SplitterModes.left) {
                        element.attr($dyn.splitter.Attributes.vertical, $dyn.splitter.SplitterModes.left);
                        element.addClass($dyn.splitter.CssClasses.left);
                    }
                    else if (value === $dyn.splitter.SplitterModes.right) {
                        element.attr($dyn.splitter.Attributes.vertical, $dyn.splitter.SplitterModes.right);
                        element.addClass($dyn.splitter.CssClasses.right);
                    }
                    else {
                        element.attr($dyn.splitter.Attributes.vertical, $dyn.splitter.SplitterModes.both);
                        element.addClass($dyn.splitter.CssClasses.left);
                        element.addClass($dyn.splitter.CssClasses.right);
                    }
                    $dyn.splitter.CreateHandles(element);
                    // If width is set (or later set) to SizeToContent then set the width to fixed so that it can be resized
                    var elementContext_1 = $dyn.context(targetElement);
                    if (elementContext_1) {
                        // tslint:disable-next-line:no-shadowed-variable
                        $dyn.observe(elementContext_1.LayoutWidth, function (value) {
                            if (value === $dyn.layout.Size.content) {
                                $dyn.setValue(elementContext_1, "LayoutWidth", $dyn.layout.Size.fixed);
                            }
                        });
                    }
                }
            };
            VerticalSplitterBindingHandler.prototype.dispose = function (target) {
                $dyn.resizableHandle._destroyResizableHandles(target);
            };
            return VerticalSplitterBindingHandler;
        }());
        bindingHandlers.verticalSplitter = new VerticalSplitterBindingHandler();
        /**
         * Initialize a horizontal splitter on a control given the direction/side.
         * Moves the splitter to the neighboring control if needed. The non flexible element should be resizable
         */
        var HorizontalSplitterBindingHandler = /** @class */ (function () {
            function HorizontalSplitterBindingHandler() {
            }
            HorizontalSplitterBindingHandler.prototype.shouldInvoke = function (value, lastValue) {
                return lastValue !== value ? lastValue !== undefined || !!value : false;
            };
            HorizontalSplitterBindingHandler.prototype.invoke = function (targetElement, value) {
                var element = $(targetElement);
                var horizontalSplitterMode = element.attr($dyn.splitter.Attributes.horizontal);
                if (value === $dyn.splitter.SplitterModes.none) {
                    if (horizontalSplitterMode !== undefined && horizontalSplitterMode !== $dyn.splitter.SplitterModes.none) {
                        element.attr($dyn.splitter.Attributes.horizontal, $dyn.splitter.SplitterModes.none);
                        $dyn.splitter.RemoveHandle(element, $dyn.splitter.HandleDirections.north);
                        $dyn.splitter.RemoveHandle(element, $dyn.splitter.HandleDirections.south);
                    }
                }
                else {
                    if (value === $dyn.splitter.SplitterModes.top) {
                        element.attr($dyn.splitter.Attributes.horizontal, $dyn.splitter.SplitterModes.top);
                        element.addClass($dyn.splitter.CssClasses.top);
                    }
                    else if (value === $dyn.splitter.SplitterModes.bottom) {
                        element.attr($dyn.splitter.Attributes.horizontal, $dyn.splitter.SplitterModes.bottom);
                        element.addClass($dyn.splitter.CssClasses.bottom);
                    }
                    else {
                        element.attr($dyn.splitter.Attributes.horizontal, $dyn.splitter.SplitterModes.both);
                        element.addClass($dyn.splitter.CssClasses.top);
                        element.addClass($dyn.splitter.CssClasses.bottom);
                    }
                    $dyn.splitter.CreateHandles(element);
                    // If height is set (or later set) to SizeToContent then set the height to fixed so that it can be resized
                    var targetControl_1 = $dyn.context(targetElement);
                    // tslint:disable-next-line:no-shadowed-variable
                    $dyn.observe(targetControl_1.LayoutHeight, function (value) {
                        if (value === $dyn.layout.Size.content) {
                            $dyn.setValue(targetControl_1, "LayoutHeight", $dyn.layout.Size.fixed);
                        }
                    });
                }
            };
            HorizontalSplitterBindingHandler.prototype.dispose = function (target) {
                $dyn.resizableHandle._destroyResizableHandles(target);
            };
            return HorizontalSplitterBindingHandler;
        }());
        bindingHandlers.horizontalSplitter = new HorizontalSplitterBindingHandler();
    })(bindingHandlers = $dyn.bindingHandlers || ($dyn.bindingHandlers = {}));
    (function (splitter) {
        /** Remove a given splitter on a given side */
        function RemoveHandle(target, resizableSide) {
            var handle = target.children(".ui-resizable-" + resizableSide);
            if (handle.length > 0) {
                handle.remove();
            }
            // If there are any handles left, do not remove the resizable CSS class from the attached element
            var remainingHandles = target.children(".ui-resizable-handle");
            if (remainingHandles.length === 0) {
                target.removeClass("ui-resizable");
            }
        }
        splitter.RemoveHandle = RemoveHandle;
        /** Create the splitters needed on an element according to the mode */
        function CreateHandles(target) {
            var handles = $dyn.splitter.GetHandlesFromMode(target);
            // Destroy the previous handles
            $dyn.resizableHandle._destroyResizableHandles(target);
            // Add the new handles
            $dyn.resizableHandle._addResizableHandle(target, handles, 25, 25, function (event, ui) {
                if (ui.size) {
                    // If the element has an inline min width then remove it so the element can be resized.
                    target[0].style.minWidth = "";
                    var context_1 = $dyn.context(target[0]);
                    if (context_1 && context_1._parent && context_1._parent.element) {
                        // Reflow parent of resizable control
                        $dyn.layout.reflow(context_1._parent.element, true);
                    }
                }
            });
            // Register the handle listeners
            target.children(".ui-resizable-handle").mousedown($dyn.splitter.SplitterMoved);
            target.children(".ui-resizable-handle").mouseup($dyn.splitter.SplitterPlaced);
            target.children(".ui-resizable-handle").keydown($dyn.splitter.SplitterMoved);
            target.children(".ui-resizable-handle").keyup($dyn.splitter.SplitterPlaced);
            target.children(".ui-resizable-handle").each(function (i, element) {
                if (element._hammer) {
                    element._hammer.on("panstart", $dyn.splitter.SplitterMoved);
                    element._hammer.on("panend", $dyn.splitter.SplitterPlaced);
                }
            });
        }
        splitter.CreateHandles = CreateHandles;
        /** When the splitter is moved, change the splitter element width to fixed size in the direction it is resizing */
        function SplitterMoved(e) {
            var splitterHandle = $(e.target);
            var control = $(e.target).parent();
            var controlContext = $dyn.context(control[0]);
            if (splitterHandle.hasClass("ui-resizable-" + $dyn.splitter.HandleDirections.east) || splitterHandle.hasClass("ui-resizable-" + $dyn.splitter.HandleDirections.west)) {
                if (controlContext && $dyn.value(controlContext.LayoutWidth) === $dyn.layout.Size.available) {
                    $dyn.setValue(controlContext, "LayoutWidth", control.width() + "px");
                    // tslint:disable-next-line:no-shadowed-variable
                    var rightSibling = control.next();
                    // In the case of the vertical splitter, look for a layout-column on th eparent, and in that case, we need to find the right sibling there. We do not need to do this
                    // for horizontal splitters because the next sibling will be in the same column if we need to change its height.
                    var parentOfResizable = control.parent();
                    if (parentOfResizable.hasClass("layout-column")) {
                        // If the splitter group is inside of a layout column, then the right sibling is going to be inside of the next layout column. Assume that the first child
                        // in the next layout column element is the right sibling, otherwise, the splitter will not behave correctly.
                        rightSibling = parentOfResizable
                            .next()
                            .children()
                            .first();
                    }
                    // If the resizable element is Width=SizeToAvailable, and its right sibling is Width=SizeToContent/Fixed, then we want to make the right sibling be Width=SizeToAvailable
                    // instead so that the splitter behaves correctly.
                    if (rightSibling.length > 0) {
                        // tslint:disable-next-line:no-shadowed-variable
                        var rightSiblingContext = $dyn.context(rightSibling[0]);
                        if (rightSiblingContext && $dyn.value(rightSiblingContext.LayoutWidth) !== $dyn.layout.Size.available) {
                            $dyn.setValue(rightSiblingContext, "LayoutWidth", $dyn.layout.Size.available);
                        }
                    }
                }
            }
            else {
                if (controlContext && $dyn.value(controlContext.LayoutHeight) === $dyn.layout.Size.available) {
                    $dyn.setValue(controlContext, "LayoutHeight", control.height() + "px");
                    var rightSibling = control.next();
                    // If the resizable element is Height=SizeToAvailable, and its next sibling is Height=SizeToContent/Fixed, then we want to make the next sibling be Height=SizeToAvailable
                    // instead so that the splitter behaves correctly.
                    if (rightSibling.length > 0) {
                        var rightSiblingContext = $dyn.context(rightSibling[0]);
                        if (rightSiblingContext && $dyn.value(rightSiblingContext.LayoutHeight) !== $dyn.layout.Size.available) {
                            $dyn.setValue(rightSiblingContext, "LayoutHeight", $dyn.layout.Size.available);
                        }
                    }
                }
            }
        }
        splitter.SplitterMoved = SplitterMoved;
        /** When the splitter is placed, set the LayoutWidth again to the final size */
        function SplitterPlaced(e) {
            var handle = $(e.target);
            var control = handle.parent();
            var controlContext = $dyn.context(control[0]);
            if (handle.hasClass("ui-resizable-" + $dyn.splitter.HandleDirections.east) || handle.hasClass("ui-resizable-" + $dyn.splitter.HandleDirections.west)) {
                // Persist the personalization settings so the new width is saved
                if (controlContext) {
                    $dyn.callFunction(controlContext.PersistPersonalization, controlContext, ["width", control.width()]);
                }
            }
            else {
                // Persist the personalization settings so the new height is saved
                if (controlContext) {
                    $dyn.callFunction(controlContext.PersistPersonalization, controlContext, ["height", control.height()]);
                }
            }
        }
        splitter.SplitterPlaced = SplitterPlaced;
        /** Gets a string with the resizable handles needed for the splitter directions */
        function GetHandlesFromMode(target) {
            var handles = "";
            // Horizontal handles
            var horizontalSplitterMode = target.attr("data-dyn-horizontalsplitter");
            if (horizontalSplitterMode === $dyn.splitter.SplitterModes.top) {
                handles = $dyn.splitter.HandleDirections.north;
            }
            else if (horizontalSplitterMode === $dyn.splitter.SplitterModes.bottom) {
                handles = $dyn.splitter.HandleDirections.south;
            }
            else if (horizontalSplitterMode === $dyn.splitter.SplitterModes.both) {
                handles = $dyn.splitter.HandleDirections.north + "," + $dyn.splitter.HandleDirections.south;
            }
            var separator = handles.length > 0 ? "," : "";
            // Vertical handles
            var verticalSplitterMode = target.attr("data-dyn-verticalsplitter");
            if (verticalSplitterMode === $dyn.splitter.SplitterModes.left) {
                handles = handles + separator + $dyn.splitter.HandleDirections.west;
            }
            else if (verticalSplitterMode === $dyn.splitter.SplitterModes.right) {
                handles = handles + separator + $dyn.splitter.HandleDirections.east;
            }
            else if (verticalSplitterMode === $dyn.splitter.SplitterModes.both) {
                handles = handles + separator + $dyn.splitter.HandleDirections.west + "," + $dyn.splitter.HandleDirections.east;
            }
            return handles;
        }
        splitter.GetHandlesFromMode = GetHandlesFromMode;
    })(splitter = $dyn.splitter || ($dyn.splitter = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=html-binding-splitter.js.map
